"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TableColumnContext = _interopRequireDefault(require("./TableColumnContext"));
var _TableColumnCell = _interopRequireDefault(require("./TableColumnCell"));
var _TableColumnHeader = _interopRequireDefault(require("./TableColumnHeader"));
const TableColumn = () => {
  const context = _react.default.useMemo(() => ({}), []);
  return /*#__PURE__*/_react.default.createElement(_TableColumnContext.default.Provider, {
    value: context
  });
};
TableColumn.displayName = 'TableColumn';
var _default = exports.default = Object.assign(TableColumn, {
  Cell: _TableColumnCell.default,
  Header: _TableColumnHeader.default
});